import React, { useState, useEffect, createContext } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Header.css';
import { motion } from 'framer-motion';

// Create a context for the menu state
export const MenuContext = createContext();

const Header = ({ switchContent }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Effect to disable scrolling when menu is open
    useEffect(() => {
        if (isMenuOpen) {
            // Disable scrolling
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling
            document.body.style.overflow = 'auto';
        }

        // Cleanup function to ensure scrolling is re-enabled when component unmounts
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMenuOpen]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleNavigation = (content) => {
        if (content !== 'exhibit') {
            switchContent(content);
            // Only close the menu if not navigating to About
            if (content !== 'about') {
                setIsMenuOpen(false);
            }
        }
    };

    return (
        <MenuContext.Provider value={{ isMenuOpen, setIsMenuOpen, toggleMenu, closeMenu }}>
            <header className="header">
                <nav className="nav">
                    <Link to="/" onClick={() => handleNavigation('featured')}>
                        <div className="logo-container">
                            <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="nav__logo" />
                            <span className="site-name">IMMUTA</span>
                        </div>
                    </Link>
                    
                    <div className="nav__links">
                        <Link to="/" onClick={() => handleNavigation('featured')} className="nav__link">HOME</Link>
                        <Link to="/" onClick={() => handleNavigation('gallery')} className="nav__link">COLLECT</Link>
                        <a href="https://immuta.art/hash-gallery" target="_blank" rel="noopener noreferrer" className="nav__link">EXHIBIT</a>
                        <Link to="/" onClick={() => handleNavigation('about')} className="nav__link">ABOUT</Link>
                    </div>
                    
                    <div className="nav__toggle" onClick={toggleMenu}>
                        {isMenuOpen ? <FaTimes /> : <FaBars />}
                    </div>
                </nav>
            </header>
            {isMenuOpen && (
                <motion.div
                    className="fullscreen-menu"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <ul className="fullscreen-menu__items">
                        <li className="fullscreen-menu__item" onClick={() => handleNavigation('featured')}>HOME</li>
                        <li className="fullscreen-menu__item" onClick={() => handleNavigation('gallery')}>
                            COLLECT
                        </li>
                        <li className="fullscreen-menu__item">
                            <a href="https://immuta.art/hash-gallery" target="_blank" rel="noopener noreferrer" className="fullscreen-menu__link">EXHIBIT</a>
                        </li>
                        <li className="fullscreen-menu__item" onClick={() => handleNavigation('about')}>ABOUT</li>
                    </ul>
                </motion.div>
            )}
        </MenuContext.Provider>
    );
};

export default Header;
